// frontend/src/features/regions/components/StateSelector.tsx
import React from 'react';
import CustomSelect from '../../../components/CustomSelect/CustomSelect';
import styles from './StateSelector.module.css'; 

interface StateSelectorProps {
    selectedState: string | null;
    onStateChange: (state: string | null) => void;
    availableStates: string[]; 
}

const StateSelector: React.FC<StateSelectorProps> = ({
    selectedState,
    onStateChange,
    availableStates 
}) => {
    const options = [
        { value: '', label: 'Todas as Regiões' },
        ...availableStates.map((state) => ({
            value: state,
            label: state
        }))
    ];

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        onStateChange(value === '' ? null : value);
    };

    return (
        <div className={styles.selectorContainer}>
            <CustomSelect
                id="state-select"
                value={selectedState || ''}
                onChange={handleChange}
                options={options}
                placeholder="Todas as Regiões"
            />
        </div>
    );
};

export default StateSelector;